/**
 * @fileoverview Syndicator Showdown — Notification Bell
 * @module components/notifications/NotificationBell
 *
 * Small icon button (sidebar / more-sheet) showing the unread notification
 * count and opening the NotificationCenter drawer on click.
 */

import React, { useState } from 'react';
import { useNotificationFeed } from '../../hooks/useNotificationFeed';
import NotificationCenter from './NotificationCenter';
import './NotificationBell.css';

export default function NotificationBell({ user, variant = 'icon', label = 'Notifications', onOpen }) {
  const { unreadCount } = useNotificationFeed(user, { limit: 30 });
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    onOpen?.();
  };

  return (
    <>
      {variant === 'icon' ? (
        <button
          type="button"
          className="notif-bell"
          onClick={handleOpen}
          aria-label={`${label}${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
        >
          <span className="notif-bell__icon">🔔</span>
          {unreadCount > 0 && (
            <span className="notif-bell__badge">{unreadCount > 9 ? '9+' : unreadCount}</span>
          )}
        </button>
      ) : (
        <button type="button" className="more-sheet__item" onClick={handleOpen}>
          <span className="more-sheet__item-icon">🔔</span>
          <span className="more-sheet__item-label">{label}</span>
          {unreadCount > 0 && (
            <span className="notif-bell__sheet-badge">{unreadCount > 9 ? '9+' : unreadCount}</span>
          )}
        </button>
      )}

      <NotificationCenter user={user} isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
}
